import { z } from 'zod';
/**
 * Authoritative enumeration of channel kinds recognised by the platform.
 *
 * Mirrors the Postgres `channel_kind` enum in `db/schema.sql`. Adding a new
 * channel means adding a value here AND a matching migration — intentional
 * coupling so schema stays the source of truth.
 */
export const ChannelKindSchema = z.enum(['gmail', 'imap', 'smtp_inbound', 'web_form']);
//# sourceMappingURL=channel-kind.js.map